require('./index.less');
require('../../app/app');

var pageConfig = window.pageConfig;
var validate = pageConfig.validate;
var myProjectList = pageConfig.projectList;
var util = require('../../app/util');
var loadData = util.loadData;
var i18n = require('i18n');
var projectDetail = require('./projectDetail.html');
var projectInfo = require('./projectInfo.html');
var deliveryManagement = require('./deliveryManagement.html');
var userItem = require('./userItem.html');
var userList = require('./userList.html');
var addProjectLayer = require('./addProjectLayer');
var cloneProject = require('./cloneProject');
var addUserLayer = require('./addUserLayer');
var transferUserLayer = require('./transferUserLayer');
var indexTPL = require('./index.html');

var currentProjectUsers;
var roleMap = pageConfig.roleMap;
var localUser = {
  id: parseInt(decodeURIComponent(util.getCookie('uid') || ''), 10)
};

// Set nav title selected
$('header div.nav a.my-project').addClass('selected');

function getRoleList(role) {
  var ret = [];
  var self = roleMap[role];

  for (var i in roleMap) {
    if (roleMap[i] >= self) {
      ret.push(i);
    }
  }
  return ret;
}

function showDelBtn(role) {
  return localUser.isCreator || !(roleMap[localUser.role] > roleMap['master'] || roleMap[localUser.role] >= roleMap[role]);
}

function changeUserRole(value, text) {
  var list = $('.project-list-folder');
  var pid = list.find('.selected').data('project-id');
  var user = $(this).data('user');
  var role = value;
  var td = $(this).closest('td');
  var row = $(this).closest('tr');

  loadData('/project/' + pid + '/changeUserRole/' + user, {
    role: role
  }, 'POST', function(res) {
    if (role == localUser.role) {
      td.html(role);
      row.find('td:last .del-user').hide();
      return;
    }

    var btn = '<button data-user="' + user + '" class="ui button del-user" >' + i18n('common.remove') + '</button>';
    var showBtn = showDelBtn(role);

    if (showBtn) { //change user role event
      if (row.find('td:last .del-user').length) {
        row.find('td:last .del-user').show();
      } else {
        row.find('td:last').append(btn);
      }
    } else {
      row.find('td:last .del-user').hide();
    }
  });
}

function updateProjectField($inp) {
  var $field = $inp.parent();
  var projectId = $('.project-info .project-id').text().trim();
  var name = $field.attr('name');
  var value = $inp.val().trim();
  if (name === 'name') {
    if (!value || /^test/.test(value) || value.length > validate.maxProjectName 
      || value.length < validate.minProjectName) {
      $field.html($field.data('lastContent'));
      return
    } 
  }
  if (name === 'desc' && value.length > validate.maxDescription) {
    $field.html($field.data('lastContent'));
    return;
  }

  if (value === $field.data('lastContent')) {
    $field.html(value);
    return;
  }
  loadData('/project/ ' + projectId + '/updateField', {
    field: name,
    value: value
  }, 'POST', function(res) {
    //if (name === 'name' || name === 'description') {
      value = value.replace(/</g,'&lt;');
    //}
    $field.html(value);
    if (name === 'name') {
      $('.project-list-folder li[data-project-id=' + projectId + ']').html(value);
    }
  });
}


var App = {
  init: function() {
    if (pageConfig.error) {
      util.show({
        icon: 'error',
        content: pageConfig.error
      });
      return;
    }

    const folderProjects = {};
    var list = myProjectList.projects.filter((item) => {
      if (item.folder_id) {
        folderProjects[item.folder_id] = folderProjects[item.folder_id] || [];
         folderProjects[item.folder_id].push(item);
        return false
      }
      return true
    });
    pageConfig.folders.forEach((item) => {
      item.projects = folderProjects[item.id] || [];
      item.hasChildren = !!item.projects.length;
    })
    var delList = myProjectList.deletedProjects;
    var indexHTML = indexTPL({
      projectList: list,
      deletedProjectList: delList,
      folders: pageConfig.folders || [],
      i18n: i18n()
    });
    $(indexHTML).appendTo($('body'));

    var list = $('.project-list-folder');
    var dropOverEle;
    var dragEle;
    var dblclick = 0;
    list.on('click', 'li:not(.selected)', function(e) {
      var target = $(e.target);
      var pid = target.data('project-id');

      pid && loadData('/project/' + pid, {}, function(res) {
        var data = res.data;
        if (data) {
          data = handleProjectInfo(data, pid);
          localUser.data = data;
          data.pid = pid;
          var html = projectDetail(data);
          $('.project-detail').html(html);

          list.find('.selected').removeClass('selected')
            .closest('.folder-wrap').removeClass('current');
          target.addClass('selected');
          target.closest('.folder-wrap').addClass('show-list')
            .find('.folder').addClass('open');

          html = projectInfo(data);
          $('.project-wrap').html(html);
        } else {
          target.hide();
        }
      });

      try {
        localStorage.pid = pid;
      } catch (e) {}
    }).on('dragstart', 'li', function (e) {
      dragEle = $(e.currentTarget);
      dropOverEle = null;
    }).on('dragend', 'li', function (e) {
      const srcWrap = dragEle.closest('.folder-wrap')[0];
      const dstWrap = dropOverEle ;
      if (srcWrap != dstWrap) {
        loadData('/folder/change', {
          pid: dragEle.data('project-id'),
          from: srcWrap ? $(srcWrap).data('fid') : 0,
          to: dstWrap ? $(dstWrap).data('fid') : 0
        }, 'POST', function(res) {
          const selected = dragEle.hasClass('selected');
          if (srcWrap && selected) {
            $(srcWrap).removeClass('current');
          }
          const wrap = dragEle.closest('.folder-wrap');
          const parent = dragEle.parent();
          dragEle.remove();
          wrap.toggleClass('has-children', !!parent.find('li').length)

          if (dstWrap) {
            $(dstWrap).find('ul').append(dragEle.prop('outerHTML'));
            $(dstWrap).addClass('has-children');
            if (selected) {
              $(dstWrap).addClass('current');
            }
          } else {
            $('.project-list').prepend(dragEle.prop('outerHTML'))
          }
        });
      }
      $(dropOverEle).removeClass('drag-hover');
    }).on('dragenter', '.folder-wrap', function (e) {
      const target = $(e.target);
      const wrap = target.closest('.folder-wrap');
      if (dropOverEle !== wrap[0]) {
        $('.drag-hover').removeClass('drag-hover');
        wrap.addClass('drag-hover');
      }
      dropOverEle = wrap[0];
    }).on('dragenter', '.project-list', function () {
      $('.drag-hover').removeClass('drag-hover');
      dropOverEle = null;
    }).on('click', '.folder-name', function (e) {
      const cur = $(e.target);
      const target = $(e.currentTarget);
      if (cur.parent().hasClass('folder-op')) {
        if (cur.hasClass('edit-folder')) {
          target.addClass('edit');
          target.find('input').val(target.find('span').text()).focus();
        } else {
          loadData('/folder/remove', {
            id: target.closest('.folder-wrap').data('fid')
          }, 'POST', function(res) {
            target.closest('.folder-wrap').remove();
          });
        }
        return
      }
      if (cur.is('input')) {
        return;
      }
      
      setTimeout(function () {
        if (dblclick) {
          dblclick++;
          if (dblclick > 2) {
            dblclick = 0;
          }
          return
        }
        target.parent().find('ul').toggle(200, function () {
          target.find('.folder').toggleClass('open');
        });
      }, 200);
    }).on('dblclick', '.folder-name', function (e) {
      dblclick = 1;
      if (e.target.tagName.toLowerCase() === 'input') {
        return;
      }

      const target = $(e.currentTarget);
      target.addClass('edit');
      target.find('input').val(target.find('span').text()).focus();
    });



    $('.folder-list').on('blur', '.folder-name input', function (e) {
      submitFolderName($(e.currentTarget))
    }).on('keydown', '.folder-name input', function (e) {
      if (e.keyCode === 13) {
        submitFolderName($(e.currentTarget))
      }
    });
    function submitFolderName (target) {
      const val = target.val().trim();
      const old = target.parent().find('span').text().trim();
      if (val.length > validate.maxFolderName) {
        return util.show({
          icon: 'warning',
          content: i18n('folder.name.too.long', {max: validate.maxFolderName})
        });
      }
      if (val && val !== old) {
        loadData('/folder/rename', {
          id: target.closest('.folder-wrap').data('fid'),
          name: val
        }, 'POST', function(res) {
          target.parent().find('span').text(val);
        });
      }
      target.parent().removeClass('edit');
    }

    

    $('body').on('click', '.add-project', function() {
      $('.add-project-layer').modal('show');
    }).on('click', '.add-folder', function () {
      loadData('/folder/add', {}, 'POST', function(res) {
        const data = res.data;
        const html = `<div class="folder-wrap" data-fid="${data.id}">
          <div class="folder-name">
            <i class="folder outline  icon"></i> <span>${data.name}</span>
            <input type="text">
            <div class="folder-op">
              <i class="edit-folder  fas fa-pencil-alt"></i>
              <i class="remove-folder far fa-trash-alt" style="margin-left: 5px;"></i>
            </div>
          </div>
          <ul></ul>
        </div>`;

        $('.folder-list').append(html)
      });
    });

    function onAddProject (data) {
      data.name = data.name.replace(/</, '&lt;');
      var $item = $('<li class="elli" data-project-id="' + data.id + '">' + data.name + '</li>');
      $item.prependTo($('.project-list'));


      var empty = $('.add-my-first-project');

      if (empty.length) {
        empty.remove();
        $('.wrapper').css('display', 'table');
      }

      $item.click();
    }
    addProjectLayer(onAddProject);

    cloneProject(onAddProject);

    function handleProjectInfo(data, pid) {

      data.time_created = util.format(data.time_created);
      var site = location.host.split('.');
      site = site[site.length - 2] + '.' + site[site.length - 1];
      data.workbenchUrl = location.protocol +
            '//workbench.' + site  +
            '/proj/' + pid;

      var found = 0;
      var user;
      localUser.isCreator = data.creator === localUser.id;
      data.showPublic = localUser.isCreator;
      data.is_public = data.is_public === 'Y' && localUser.isCreator;
      data.showTransfer = localUser.isCreator;
      data.users.some(function(item) {
        if (item.id == localUser.id) {
          localUser.role = item.role;
          data.showBtn = roleMap[item.role] < roleMap['master']; // 只有 owner才能删除成员, 只有creator 才能删 owner
          data.showEditable = roleMap[item.role] <= roleMap['master']; //  只有owner和master才能编辑标题和描述
          data.showClone = roleMap[item.role] <= roleMap['owner']; //  只有owner才能克隆项目
          found++;
        }
        if (item.id === data.creator) {
          user = item;
          found++;
        }
        return found > 1;
      });
      data.role = localUser.role;
      data.nickname = user.nickname;
      currentProjectUsers = data.users;
      data.delText = i18n(localUser.id === data.creator ? 'delete' : 'leave');
      return data;
    }

    $('.project-detail').on('click', '.project-tabs > li:not(.selected)', function(e) {
      var target = $(e.target).closest('li');
      var tab = target.data('tab');
      var pid = list.find('.selected').data('project-id');
      var html;

      function changeTab() {
        $('.project-tabs .selected').removeClass('selected')
        target.addClass('selected');
      }

      switch (tab) {
        case 'project-info':
          loadData('/project/' + pid, {}, function(res) {
            if (res.data) {
              var data = handleProjectInfo(res.data, pid);
              localUser.data = data;
              html = projectInfo(data);
              $('.project-wrap').html(html);
              changeTab();
            } else {
              target.hide();
            }
          });
          break;
        case 'delivery-management':
          var site = location.host.split('.');
          site = site[site.length - 2] + '.' + site[site.length - 1];
          html = deliveryManagement({
            reporter: localUser.role === 'reporter',
            deliveryUrl: '//delivery.' + site + 
              '/proj/' + pid + '/release/home'
          });
          $('.project-wrap').html(html);
          changeTab();
          break;
        case 'authorization':
          loadData('/project/' + pid + '/users/', {}, function(res) {
            res.data.forEach(function(item) {
              var itemRole = roleMap[item.role];
              var userRole = roleMap[localUser.role];
              if (item.user_id == localUser.id  || userRole > roleMap['master'] ||  userRole > itemRole || (userRole == itemRole && !localUser.isCreator)) {
                item.showList = false;
              } else {
                item.showList = true;
                item.roleList = getRoleList(localUser.role, item.role);
              }
              var user;
              currentProjectUsers.some(function (it) {
                if (it.id === item.user_id) {
                  user = it;
                  return true;
                }
              })

              if (user) {
                item.nickname = user.nickname;
                item.avatar = user.avatar;
              }
            });

            res.showAddUser = roleMap[localUser.role] <= roleMap['master']; // master 和 owner 都能添加成员  
            html = userList(res);
            $('.project-wrap').html(html);
            changeTab();


            $('.project-wrap .dropdown').dropdown({
              onChange: changeUserRole
            });
          });
          break
      }
    });

    // Grant
    $('.project-detail').on('click', 'a.button.grant-project', function() {
      $(this).parent().parent().parent()
        .prev().find('li[data-tab=authorization]')
        .click();
    });

    // Public
    $('.project-detail').on('click', 'a.button.public-project', function() {
      var self =  this;
      var pid = $(this).attr('data-project-id');
      var open = $(this).find('.icon').hasClass('unlock');

      util.showConfirm( i18n('home.confirm.' + (open ? 'un' : '') + 'public.project'), function() {
        loadData('/project/' + pid + '/public', {
          is_public: !open 
        }, 'POST', function(res) {
          $(self).find('.icon').toggleClass('unlock');
          $(self).find('span').text(i18n((open ? '' : 'un') + 'public.project'));
        });
      }, function() {});
    });

    // Transfer
    $('.project-detail').on('click', 'a.button.transfer-project', function() {
      transferUserLayer.show(localUser.data.users, function () {
        window.location.reload();
      });
    });

    // Delete
    $('.project-detail').on('click', '.button.delete-project', function(e) {
      var pid = $(this).attr('data-project-id');
      var creator = $(this).attr('data-creator');
      var tip = creator == localUser.id ? 'home.confirm.remove.project' : 'tip.exit';
      
      util.showConfirm(i18n(tip), function() {
        loadData('/project/' + pid + '/delete', {
        }, 'POST', function(res) {
          window.location.reload();
        });
      }, function() {});
    });

    // Clone
    $('.project-detail').on('click', '.button.clone-project', function(e) {
      var pid = $(this).attr('data-project-id');
      var pname = $(this).attr('data-project-name');
      util.showConfirm(i18n('home.clone.tip'), function () {
        var layer = $('.clone-project-layer');
      
        layer.find('input[name=name]').val('New ' + pname);
        layer.find('input[name=desc]').val('Cloned From ' + pname);
        layer.data('pid', pid).data('pname', pname);
        layer.modal('show');
      }, null, i18n('home.sure'));
    });

    $('body').on('click', '.del-project-list-title', function() {
      if ($(this).hasClass('expended')) {
        $(this).removeClass('expended')
          .find('i.caret').removeClass('down').addClass('left');
        $(this).next().hide('blind');
      } else {
        $(this).addClass('expended')
          .find('i.caret').addClass('down').removeClass('left');
        $(this).next().show('blind');
      }
    });

    addUserLayer(function(data) {
      data.showBtn = showDelBtn(data.role);
      $('.project-wrap .developer-list tbody').prepend(userItem(data));

      $('.project-wrap .developer-list tr').eq(1).find('.dropdown').dropdown({
        onChange: changeUserRole
      });
    });

    $('body').on('click', '.add-user', function() {
      $('.add-user-layer .dropdown.role .menu .item[data-value=owner]').toggle(localUser.role === 'owner')
      $('.add-user-layer').modal('show');
    });
    $('body').on('click', '.project-wrap .del-user', function() {
      var uid = $(this).data('user');
      var pid = list.find('.selected').data('project-id');
      var row = $(this).closest('tr');

      util.showConfirm(i18n('home.confirm.remove.user'), function() {
        loadData('/project/' + pid + '/delUser/' + uid, {}, 'POST', function(res) {
          row.remove();
        });
      }, function() {});
    });

    $('body').on('click', '.project-wrap span.editable', function(e) {
      var $this = $(this);
      var lastContent = $this.text().trim();
      $this.data('lastContent', lastContent);
      var $inp = $('<input>').val(lastContent)
        .on('click', function(e) {
          e.stopPropagation();
        })
        .on('keyup', function(e) {
          if (e.keyCode === 13) {
            updateProjectField($(this));
          }
        })
        .on('blur', function(e) {
          updateProjectField($(this));
        })

      $this.html('').append($inp);
      $inp.focus();
    });

    // Undelete
    $('body').on('click', 'i.undelete', function(e) {
      var pid = $(this).closest('li').attr('data-project-id');
      loadData('/project/' + pid + '/undelete', {
      }, 'POST', function(res) {
        window.location.reload();
      });
    });

    // Delete permanent
    $('body').on('click', 'i.delete-permanent', function(e) {
      var pid = $(this).closest('li').attr('data-project-id');
      var pname = $(this).closest('li').find('.deleted-name').html().trim();
      var tips = i18n('removePermanent', {
        name: pname
      });
      util.showConfirm(tips, function() {
        loadData('/project/'  + pid +'/delete', {
          permanent: true
        }, 'POST', function(res) {
          window.location.reload();
        });
      }, function() {});
    });


    
    var empty = '<div class="button add-my-first-project add-project">' +
      '<i class="plus icon "></i>' +
      i18n('home.add.first.project') +
      '</div>';

    $('body').append(empty);

    if (list.find('li').length) {
      if (location.hash) {
        var match = location.hash.match(/project=(\d+)/);
        if (match) {
          var li = $('.project-list-folder li[data-project-id=' + match[1] + ']');
          if (li.length) {
            return li.click();
          }
        }
      }
      var projectId;
      try {
        projectId = localStorage.pid;
      }catch(e) {};

      var li = list.find('li[data-project-id=' + projectId  + ']');
      if (li.length) {
        li.click();
      } else {
        list.find('li:first').click();
      }
    } else {
      if (!$('.deleted-project-list li').length) {
        $('.wrapper').css('display', 'none');
        $('.add-my-first-project').css('display', 'block');
      }
    }

    $('.popup').popup({
      offset: -13
    });
  }
};

// Entry
(function() {
  App.init();
})();


// WEBPACK FOOTER //
// ./src/pages/home/index.js